import { combineReducers } from 'redux'
import { reducer as dataReducer } from './data/reducer'
import auth from './data/auth/reducer'
import { ADVISOR_CLIENT_CLOSED } from './data/advisor/client/types'
import { ADVISOR_CLIENT_PLAN_SELECTED } from './data/advisor/plan/types'
import { USER_LOGGED_OUT } from './data/auth/types'

export const appReducer = combineReducers({
  auth,
  shared_data: dataReducer
})

export const rootReducer = ( state, action ) => { 
  switch (action.type) {
    case ADVISOR_CLIENT_PLAN_SELECTED:
      if (!!state.shared_data.bmc.futurechoices) {
        state.shared_data.bmc.futurechoices.activities = []
        state.shared_data.bmc.futurechoices.debts = []
        state.shared_data.bmc.futurechoices.expenses = []
        state.shared_data.bmc.futurechoices.income = []
        state.shared_data.bmc.futurechoices.plan = {}
        state.shared_data.bmc.futurechoices.plans = []
        state.shared_data.bmc.futurechoices.properties = []
        state.shared_data.bmc.futurechoices.renovations = []
        state.shared_data.bmc.futurechoices.report = []
        state.shared_data.bmc.futurechoices.savings = []
        state.shared_data.bmc.futurechoices.vacations = []        
      }
      if (!!state.shared_data.bmc.thisyear) {
        state.shared_data.bmc.thisyear.debts = []
        state.shared_data.bmc.thisyear.faq = []
        state.shared_data.bmc.thisyear.income = []
        state.shared_data.bmc.thisyear.lifestyle_expenses = []
        state.shared_data.bmc.thisyear.properties = []
        state.shared_data.bmc.thisyear.savings = []      
      }
      break
    case ADVISOR_CLIENT_CLOSED: 
      if (!!state.shared_data.advisor) {
        state.shared_data.advisor.client = {}
        state.shared_data.advisor.clients = []
        state.shared_data.advisor.drawdown = []
        state.shared_data.advisor.plans = []
      }
      if (!!state.shared_data.bmc.futurechoices) {
        state.shared_data.bmc.futurechoices.activities = []
        state.shared_data.bmc.futurechoices.debts = []
        state.shared_data.bmc.futurechoices.expenses = []
        state.shared_data.bmc.futurechoices.income = []
        state.shared_data.bmc.futurechoices.plan = {}
        state.shared_data.bmc.futurechoices.plans = []
        state.shared_data.bmc.futurechoices.properties = []
        state.shared_data.bmc.futurechoices.renovations = []
        state.shared_data.bmc.futurechoices.report = []
        state.shared_data.bmc.futurechoices.savings = []
        state.shared_data.bmc.futurechoices.vacations = []        
      }
      if (!!state.shared_data.bmc.thisyear) {
        state.shared_data.bmc.thisyear.debts = []
        state.shared_data.bmc.thisyear.faq = []
        state.shared_data.bmc.thisyear.income = []
        state.shared_data.bmc.thisyear.lifestyle_expenses = []
        state.shared_data.bmc.thisyear.properties = []
        state.shared_data.bmc.thisyear.savings = []      
      }
      state.shared_data.help = {}
      state.shared_data.bmc.settings = {}
      state.shared_data.user = {loading: true}
      state.shared_data.bmc.user_summary = {}
      state.shared_data.wizard = []
      //const clients = state.shared_data.advisor.clients       
      //state.shared_data = undefined
      //state.shared_data = appReducer(state, action).shared_data
      //state.shared_data.advisor.clients = clients 
      break
    case USER_LOGGED_OUT:
      state = undefined
      break
    default:
  }
  return appReducer(state, action)
}
